import mutations from './mutations';
import appAxios from '@/utility/appAxios';
import { endpoints } from '@/services/api';

const state = () => ({
    user_info: {},
});

const getters = {
    user_info: state => state.user_info,
};

const actions = {
    get({ commit }) {
        appAxios.post(endpoints.profile_get).then(response => {
            if (response.data.status === true) {
                commit('setUserInfo', response.data.data);
            }
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};